import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {catchError,  map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error, success} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {SendBackResult} from '../../shared';
import {L10nTranslationService} from 'angular-l10n';
import {IsSfInvoicedAction, isSfInvoicedActionTypes, IsSfInvoicedFailAction, IsSfInvoicedSuccessAction} from '../actions/client-is-sf-invoiced';
import {LoadSubAnomalyListAction} from '../actions/subscription-list';
import {SubscriptionsListService} from '../services/subscriptions-list.service';

@Injectable()
export class IsSfInvoicedEffect extends BaseEffect {


  // @ts-ignore
  isSFInvoiced$ = createEffect(() => { return this.actions$.pipe(
    ofType(isSfInvoicedActionTypes.IS_SF_INVOICED),
    debug('update contract link action received.'),
    map((action: IsSfInvoicedAction) => action.payload),
    switchMap((payload) =>
      this.subscriptionsListService.isSFInvoiced(payload).pipe(
        switchMap((res: SendBackResult<boolean>) => of(new IsSfInvoicedSuccessAction() ,
          new LoadSubAnomalyListAction())),
        catchError(res => this.catchResponseError(res)))))
  });

  isSFInvoicedSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(isSfInvoicedActionTypes.IS_SF_INVOICED_SUCCESS),
    debug('update success contract link action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(([data, client]) => [
      success(this.translation.translate('SF_INVOICED-STATUS_UPDATE_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  )});


  isSFInvoicedFail$ = createEffect(() => { return this.actions$.pipe(ofType(isSfInvoicedActionTypes.IS_SF_INVOICED_FAIL),
    debug('A server error occurred while update contract.'),
    map((err: IsSfInvoicedFailAction) =>
      error(this.translation.translate('SF_UPDATE_STATUS_IS_INVOICED_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private subscriptionsListService: SubscriptionsListService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new IsSfInvoicedFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new IsSfInvoicedFailAction(response['error'].message);
  }
}
